<!--
 * @Author       : 花裤衩<白永明><yongming.bai@outlook.com>
 * @Date         : 2026-07-01 15:24:34 +0800
 * @LastEditors  : 花裤衩<白永明><yongming.bai@outlook.com>
 * @LastEditTime : 2026-07-07 13:44:51 +0800
 * @FilePath     : /ai-agent-lumina/src/components/global/ai-rec-short/src/izt-ai-rec-short.vue
 * @Description  : AI推荐理由 简短
-->
<style lang="scss" scoped>
.izt-ai-rec-short-container {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 0;
  .label {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    [class*="icon-"] {
      font-size: 22px!important;
      background: linear-gradient(141deg, #5B28CE 0%, #716FFF 34.56%, #DAE3F9 100%);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      filter: drop-shadow(0px 5px 6px rgba(0,0,0,0.1));
    }
    .label-text {
      font-weight: 400;
      font-size: 24px;
      color: rgba(0,0,0,0.45);
    }
  }
  .value {
    font-weight: 400;
    font-size: 28px;
    color: rgba(0,0,0,0.65);
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    span {
      &.carousel-leaving {
        animation: rec-carousel-slide-out 0.3s ease forwards;
      }
      &.carousel-entering {
        animation: rec-carousel-slide-in 0.3s ease forwards;
      }
    }
  }
}
@keyframes rec-carousel-slide-out {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-10px);
  }
}
@keyframes rec-carousel-slide-in {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>

<template>
  <div class="izt-ai-rec-short-container" v-if="displayText">
    <div class="label">
      <izt-icon class-name="icon-a-179show_AIbiaoshi"></izt-icon>
      <span class="label-text">{{ $t('card.AI推荐') }}</span>
    </div>
    <div class="value">
      <span :class="animClass">{{ displayText }}</span>
    </div>
  </div>
</template>

<script setup name="izt-ai-rec-short">
  import { ref, watch, onUnmounted } from 'vue';

  defineOptions({ name: 'izt-ai-rec-short' })

  const props = defineProps({
    text: {
      type: [String, Array],
      default: ''
    }
  });

  const displayText = ref('');
  const animClass = ref('');
  const currentIndex = ref(0);
  let carouselTimer = null;
  let switchTimer = null;

  /**
   * 停止轮播
   */
  const stopCarousel = () => {
    if (carouselTimer) {
      clearInterval(carouselTimer);
      carouselTimer = null;
    }
    if (switchTimer) {
      clearTimeout(switchTimer);
      switchTimer = null;
    }
  };

  /**
   * 启动轮播（仅在数组长度 > 1 时调用）
   */
  const startCarousel = () => {
    const list = props.text;
    if (!Array.isArray(list) || list.length < 2) return;

    // 随机初始索引
    const initialIndex = Math.floor(Math.random() * list.length);
    displayText.value = list[initialIndex];
    currentIndex.value = initialIndex;
    animClass.value = '';

    carouselTimer = setInterval(() => {
      // 旧文字滑出
      animClass.value = 'carousel-leaving';
      switchTimer = setTimeout(() => {
        let nextIndex;
        do {
          nextIndex = Math.floor(Math.random() * list.length);
        } while (nextIndex === currentIndex.value);
        currentIndex.value = nextIndex;
        displayText.value = list[nextIndex];
        // 新文字滑入
        animClass.value = 'carousel-entering';
      }, 300);
    }, 3000);
  };

  // 监听 text 变化
  watch(() => props.text, (newVal) => {
    stopCarousel();
    if (Array.isArray(newVal)) {
      if (newVal.length > 1) {
        startCarousel();
      } else if (newVal.length === 1) {
        displayText.value = newVal[0];
        animClass.value = '';
      } else {
        displayText.value = '';
        animClass.value = '';
      }
    } else if (typeof newVal === 'string') {
      displayText.value = newVal;
      animClass.value = '';
    }
  }, { immediate: true });

  onUnmounted(() => {
    stopCarousel();
  });
</script>